<template>
  <div class="p-16 b-b-1">
    <div flex="dir:left" class="m-b-16">
      <h4 class="f-18 m-r-8" v-if="title" v-html="title"></h4>
      <div class="f-14" style="line-height: 28px">{{subTitle}}</div>
    </div>
    <Row>
      <slot></slot>
    </Row>
  </div>
</template>
<script>
  export default {
    name: "TuboCellGroup",
    data() {
      return {};
    },
    props: {
      title: String,
      subTitle: String,
    }
  };
</script>
